// pocket-price.js
(function () {
  const UPCHARGE_CENTS = 500;
  const POCKET_PROPERTY_KEY = "pocket_selection";

  function qs(sel, root = document) {
    return root.querySelector(sel);
  }
  function qsa(sel, root = document) {
    return Array.from(root.querySelectorAll(sel));
  }

  function formatMoney(cents, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  function getPocketCheckbox() {
    return qs(`input[type="checkbox"][name="properties[${POCKET_PROPERTY_KEY}]"]`);
  }

  function pocketSelected() {
    const cb = getPocketCheckbox();
    return !!(cb && cb.checked);
  }

  function getVariantIdFromForm() {
    const idInput = qs('form[action*="/cart/add"] [name="id"]');
    return idInput ? idInput.value : null;
  }

  async function fetchVariantPriceCents(variantId) {
    if (!variantId) return null;
    try {
      const res = await fetch(`/variants/${variantId}.js`, { credentials: "same-origin" });
      if (!res.ok) return null;
      const v = await res.json();
      return typeof v.price === "number" ? v.price : null;
    } catch {
      return null;
    }
  }

  async function updateDisplayedPrice() {
    // Horizon price block wrapper
    const wrappers = qsa("product-price");
    if (!wrappers.length) return;

    const variantId = getVariantIdFromForm();
    const baseShowing = await fetchVariantPriceCents(variantId);

    wrappers.forEach((wrap) => {
      const priceSpan = wrap.querySelector('div[ref="priceContainer"] span.price');
      if (!priceSpan) return;

      // Capture base price once (from fetched variant or from existing text)
      if (!wrap.dataset.basePriceCents) {
        if (Number.isFinite(baseShowing)) {
          wrap.dataset.basePriceCents = String(baseShowing);
        } else {
          // fallback parse: "$24.00" => 2400
          const m = (priceSpan.textContent || "").replace(/[^0-9.]/g, "");
          const num = parseFloat(m);
          if (Number.isFinite(num)) wrap.dataset.basePriceCents = String(Math.round(num * 100));
        }
      }

      // Keep in sync on variant changes
      if (Number.isFinite(baseShowing)) {
        wrap.dataset.basePriceCents = String(baseShowing);
      }

      const base = parseInt(wrap.dataset.basePriceCents || "", 10);
      if (!Number.isFinite(base)) return;

      const moneyFormat =
        wrap.getAttribute("data-money-format") ||
        (window.Shopify && window.Shopify.money_format) ||
        "${{amount}}";

      const finalCents = base + (pocketSelected() ? UPCHARGE_CENTS : 0);
      priceSpan.textContent = formatMoney(finalCents, moneyFormat);
    });
  }

  function bind() {
    // initial
    updateDisplayedPrice();

    // checkbox change
    const cb = getPocketCheckbox();
    if (cb) cb.addEventListener("change", updateDisplayedPrice);

    // variant change (broad net)
    document.addEventListener("change", (e) => {
      const t = e.target;
      if (!t) return;

      const isVariantControl =
        t.name === "id" ||
        t.matches?.("[name='id']") ||
        t.matches?.("variant-selects select") ||
        t.matches?.("select[name^='options']") ||
        t.matches?.("input[name^='options']");

      if (isVariantControl) setTimeout(updateDisplayedPrice, 60);
    });

    // Horizon re-renders parts of the product form/price:
    // observe any product-price element added/changed
    const obs = new MutationObserver(() => updateDisplayedPrice());
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", bind);
})();
